import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta.js';
import { PageHead, Section, Subpage } from '../site/Subpage.jsx';
import {RuntimeNotice} from '../site/RuntimeNotice.jsx';
import {useCapabilities} from '../hooks/useCapabilities.js';

const LIVE = [
    ['A brief in plain words', 'Type the house you want in a sentence, or answer the guided brief. Either becomes the same structured brief.'],
    ['Floor plans for every level', 'A dimensioned plan for each storey, with furniture, doors and windows. It is shown only after it passes the layout checks, with a score and alternatives.'],
    ['Four elevations', 'Front, rear and both sides, drawn from the same geometry as the plan, so they always agree.'],
    ['3D model in the browser', 'Walk around and through the house in 3D, level by level. Included with a free account.'],
    ['Photoreal 3D house', 'The house built with real materials, furniture and daylight, with a walkthrough and a set of photographs. Pro includes 3 a month.'],
    ['Plain-language changes', 'Ask for a change in words ("make the living room wider") and get a new plan that still passes the checks.'],
    ['Exterior color editing', 'Preview colors on the accepted house, then apply or cancel without changing room geometry.'],
    ['SketchUp and Revit models', 'Revit-openable IFC, a native SketchUp conversion kit, COLLADA and OBJ with textures. Direct SKP is supported on a configured local Windows runtime.'],
    ['Declared surroundings', 'Roads, neighbor masses and open ground, with independent visibility controls. These are not surveyed parcels or zoning checks.'],
    ['CAD-ready drawings (DXF)', 'Drawing sheets at true scale with dimensions and a door and window schedule, ready to open in any CAD tool.'],
    ['Cost estimate for your area', 'A quantity takeoff and cost range priced for your ZIP code (US), so the plan and the budget are discussed together.'],
];
const NEXT = [
    ['Exterior image rendering', 'Server-generated exterior pictures are not enabled in this preview.'],
    ['Online native SketchUp and Revit files', 'Direct online SKP needs a supported Windows worker; direct RVT needs a Revit conversion runtime. The conversion kit and IFC are available now.'],
    ['Coordinated engineering and quantity validation', 'Structural and MEP scope, richer assemblies and independent measurement benchmarks. Concept outputs are not engineered or permit-ready.'],
    ['Scheduling', 'A build timeline from the same plan: the phases, what depends on what, and roughly how long each takes.'],
    ['Villas', 'Larger single-family homes: wings, courtyards, more suites and bigger living spaces.'],
    ['Buildings up to 7 storeys', 'Small apartment and mixed-use buildings, with shared cores, stairs and lifts, from the same kind of brief.'],
    ['Landscaping', 'The whole lot, not just the house: driveway, paths, planting and outdoor rooms, in the plan and in 3D.'],
    ['White-labeling', 'Later, let professionals present Keystone AI inside their own brand.'],
];

const Rows = ({ items, tag, cls }) => (
    <ul className="pg-roadmap gl">
        {items.map(([t, b]) => <li key={t}><h3>{t}</h3><p>{b}</p><span className={'tag ' + cls}>{tag}</span></li>)}
    </ul>
);

export const RoadmapPage = () => {
    const capabilities=useCapabilities();
    const live=LIVE.filter(([name])=>name!=='Photoreal 3D house'||capabilities?.services?.photoreal);
    const next=capabilities?.services?.photoreal?NEXT:[['Photoreal 3D house','GPU-backed generation is paused in this preview.'],...NEXT];
    useRouteMeta('/roadmap');
    return (
        <Subpage>
            <PageHead title="What works today, and what comes next.">
                A strict line between what is live and what is planned. Everything under the first heading works in the studio right now.
            </PageHead>
            <RuntimeNotice/>
            <Section id="rm-live" title={`Works today · ${live.length} features`}><Rows items={live} tag="Live" cls="live"/></Section>
            <Section id="rm-next" title="Planned, not available yet"><Rows items={next} tag="Planned" cls=""/></Section>
        </Subpage>
    );
};
